import styled from "styled-components";

export const Barra = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 20px;
  width: 100%;
  margin-top: 16px;
  font-size: 13px;
  color: #4D4F50;

  .resumo-pagina{ margin-right: auto; }

  .por-pagina{
    display: flex;
    align-items: center;
    gap: 8px;
    select{
      height: 32px;
      margin: 0;
      padding: 0 8px;
      border: 1px solid #ccc;
      border-radius: 8px;
      background: #fff;
      font-size: 13px;
    }
  }

  .paginas{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;

    /* Não herda o verde de "todo botão da página" do CSS antigo. */
    button{
      width: auto;
      min-width: 34px;
      height: 34px;
      margin: 0 !important;
      padding: 0 10px;
      border: 1px solid #E1E3E6;
      border-radius: 8px;
      background: #fff;
      color: #4D4F50;
      font-family: inherit;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;

      &:hover:not(:disabled):not(.atual){ border-color: var(--primary-color); color: var(--primary-color); background: #fff; }
      &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
      &:disabled{ opacity: .45; cursor: default; }
      &.atual{ background: var(--primary-color); border-color: var(--primary-color); color: #fff; }
    }

    .salto{ min-width: 20px; text-align: center; color: #6B6E70; }
  }
`;
